export default __webpack_public_path__ + "static/media/Wioleta.7628e714.jpg";